import { GLOBAL_THEME_DEFAULT } from '_constants';
import { Main } from 'ui/components/4-habitats/Main/Main';
import { ModuleFeature } from 'features/Modules/DynamicModule/DynamicModuleFeature';
import { Article } from 'ui/components/4-habitats/Article/Article';
import { Footer } from 'ui/components/4-habitats/Footer/Footer';
import { newsWithTagsMapper, footerMapper } from 'helpers/mappers';
import { usePageContext } from 'application/contexts/PageContext';
import { useLocaleContext } from 'application/contexts/LocaleContext';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { useSiteContext } from 'application/contexts/SiteContext';

export const NewsPageWithTagsFeature: React.FC<Content.NewsPageWithTags> = (newsPage) => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();
	const globalTheme: string = siteContext.settings.globalTheme?.setTheme ?? GLOBAL_THEME_DEFAULT;
	const dictionary = useDictionaryContext();
	const footerArgs = footerMapper(pageContext.footer, globalTheme, dictionary);
	const { pageSections } = newsPage.properties ?? {};
	const articleProps = newsWithTagsMapper(newsPage, globalTheme);
	const locale = useLocaleContext();

	let selectArticleDateStatus = dictionary.getValue('Article.Published');
	if (articleProps.articleDateStatus === 'Updated') {
		selectArticleDateStatus = dictionary.getValue('Article.Updated');
	}

	return (
		<>
			<Main>
				<Article
					{...{
						...articleProps,
						articleDate: locale.formatStringDate(articleProps.articleDate),
						articleDateStatus: selectArticleDateStatus,
					}}
				></Article>

				{pageSections.map((pageSection, index) => (
					<ModuleFeature key={index} contentModule={pageSection} />
				))}
			</Main>

			{footerArgs && <Footer {...footerArgs} />}
		</>
	);
};
